import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/services";
import { TID } from "@/constants/testIds/site";

export default function Testimonials() {
  return (
    <section
      data-testid={TID.testimonials.section}
      className="relative py-28 md:py-36 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.4em] text-white/50 mb-4 flex items-center gap-3">
            <span className="dot-gold" />
            Ils nous font confiance
          </div>
          <h2 className="font-display text-5xl md:text-7xl tracking-tighter text-white leading-[0.95]">
            Des résultats qui <span className="text-gold-gradient italic">parlent</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="relative rounded-2xl border border-white/10 bg-[#111] p-8 md:p-10 hover:border-[#d4af37]/40 transition-colors"
            >
              <Quote size={28} className="text-[#d4af37]/60 mb-6" />
              <blockquote className="text-white/85 text-lg leading-relaxed font-light">
                “{t.quote}”
              </blockquote>
              <div className="flex gap-1 mt-6 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star
                    key={k}
                    size={14}
                    className="fill-[#d4af37] text-[#d4af37]"
                  />
                ))}
              </div>
              <figcaption className="border-t border-white/10 pt-5">
                <div className="text-white font-medium">{t.name}</div>
                <div className="text-white/45 text-xs uppercase tracking-widest mt-1">
                  {t.role}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
